export const preto = '#262626'
export const rosa = '#ff11b8'
export const verde = '#0bec94'
export const roxo = '#9806f9'